export default {
    INFO_MAIL: 'info@buildbase.be',
}